import React from 'react';
import { MailIcon } from 'lucide-react';
import { BRAND } from '../data/site';
const links = [{
  label: 'Política de privacidad',
  href: '#privacidad'
}, {
  label: 'Términos y condiciones',
  href: '#terminos'
}];
export function SiteFooter() {
  return <footer className="w-full bg-sage-900 py-10 sm:py-14" data-id="element-158" data-mp="3mfg7ghbstf2r">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-159" data-mp="3hheso8leo1x3">
        <div className="flex flex-col items-center gap-7 border-b border-sage-700 pb-7 text-center sm:gap-8 sm:pb-8 lg:flex-row lg:items-start lg:justify-between lg:text-left" data-id="element-160" data-mp="3dgutkzh9uo8b">
          <div data-id="element-161" data-mp="38juoaqs8xpi9">
            <img src={BRAND.logo} alt={BRAND.name} className="mx-auto h-10 w-auto object-contain sm:h-11 lg:mx-0" data-id="element-162" data-mp="38k4by7ptjkks" />
            <p className="mx-auto mt-4 max-w-xs text-[13px] leading-relaxed text-sage-200 sm:text-[13.5px] lg:mx-0" data-id="element-163" data-mp="2yju1guv64r9b">
              {BRAND.product} · {BRAND.subtitle}
            </p>
          </div>

          <nav aria-label="Enlaces legales" className="flex flex-col items-center gap-3 sm:flex-row sm:gap-7 lg:items-start" data-id="element-164" data-mp="wsgyibcrgtfw">
            {links.map(link => <a key={link.label} href={link.href} className="text-[13.5px] font-medium text-sage-100 transition-colors duration-200 ease-soft hover:text-gold-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-400" data-id="element-165" data-mp="15paefciu74ie">
                {link.label}
              </a>)}
            <a href="mailto:hola@decoemprende.com" className="flex items-center gap-2 text-[13.5px] font-medium text-sage-100 transition-colors duration-200 ease-soft hover:text-gold-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-400" data-id="element-166" data-mp="10tv2iq4e3iom">
              <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="1eph0hmslpct6" />
              Contacto
            </a>
          </nav>
        </div>

        <p className="mt-7 text-center text-[12px] text-sage-200" data-id="element-168" data-mp="27gh25r3gm4ho">
          © {new Date().getFullYear()} {BRAND.name}. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}